module.exports = __webpack_public_path__ + "img/bankmisr.1c2a0673.jpg";